import React from 'react';
import { Button } from '@syneto/compass-react';

// There is no logging/error-reporting service in this app, so componentDidCatch just
// logs to the console. Rendering a plain inline fallback (rather than crashing the whole
// app, see SYN-2637) is the point: a bad subtree should not take the rest of the page down.
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error('ErrorBoundary caught an error:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="alert alert-danger m-3">
					Something went wrong while displaying this.
					<Button role="link" className="ms-2" onClick={ () => { this.setState({ hasError: false }); } }>Try again.</Button>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
